const getters = {
  getFacetIsOpen: (state) => (attribute) => {
    const facet = state.facets[attribute]
    if (facet != null) {
      facet.isOpen
    }
    return false
  },
  getOpenFacets: (state) => {
    let openFacets = []
    if (state.facets != null) {
      Object.keys(state.facets).forEach((key) => {
        if (state.facets[key].isOpen) {
          openFacets.push(key)
        }
      })
    }
    return openFacets
  },
  getFacetIsLoading: (state) => (attribute) => {
    const facet = state.facets[attribute]
    if (facet != null) {
      facet.isLoading
    }
    return true
  },
  getFacetAvailableValues: (state) => (attribute) => {
    if (state.facets != null) {
      const facet = state.facets[attribute]
      if (facet != null) {
        let missingValues = []
        facet.selectedObjectValues.forEach((value) => {
          const existingValue = facet.availableValues.find(({ string }) => {
            return string === value.string
          })
          if (existingValue == null) {
            missingValues.push(value)
          }
        })
        return [...new Set([...facet.availableValues, ...missingValues])]
      }
    }
    return null
  },
  getFacetSelectedValues: (state) => (attribute) => {
    const facet = state.facets[attribute]
    if (facet != null) {
      return facet.selectedValues
    }
    return null
  },
  getFacetAllSelectedValues: (state) => {
    if (state.facets != null) {
      return Object.keys(state.facets).map((key) => {
        return state.facets[key].selectedValues
      }).flat()
    }
    return []
  },
  getFacetValueIsSelected: (state) => (attribute, value) => {
    if (state.facets[attribute] != null) {
      return state.facets[attribute].selectedValues.indexOf(value) >= 0
    }
    return false
  },
  getRefinementListFilteredValuesQuery: (state) => (notIncludedAttribute = null) => {
    if (state.facets != null) {
      let refinementListValue = Object.keys(state.facets).filter((key) => {
        return key !== notIncludedAttribute && state.facets[key].selectedValues.length > 0
      })
      return refinementListValue.map((key) => {
        return {
          type: key,
          string: state.facets[key].selectedValues
        }
      })
    }
    return []
  },
  getRefinementListValuesQuery: (state) => {
    if (state.facets != null) {
      return Object.keys(state.facets).map((key) => {
        return {
          type: key,
          string: state.facets[key].selectedValues
        }
      }).filter(({ string }) => {
        return string.length > 0
      })
    }
    return []
  },
  getRefinementListValuesURL: (state) => {
    let queryURL = {}
    if (state.facets != null) {
      const facets = Object.keys(state.facets).map((key) => {
        return {
          type: key,
          string: state.facets[key].selectedValues
        }
      }).filter(({ string }) => {
        return string.length > 0
      })
      facets.forEach((facet, index) => {
        queryURL[`refinementList=${facet.type}`] = (facet.string.map((value) => value).join('~'))
      })
      return queryURL
    }
    return null
  }
}
export default getters
